import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, HostListener, OnDestroy, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Chart from 'chart.js';
import { IssueService } from '../../../../services/issue.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issues-beyond-emergency-credit-chart',
    template: '<canvas id="basechart"  #basechart *ngIf="data.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',    
    styles: [`:host { width: 90%; position: relative; display:block; }`]

})
export class IssuesBeyondEmergencyCreditChartComponent implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    polarAreaData: any;
    clientId: number;
    dataNotBeyondEmergency: any[] = [];
    dataNotUsingOverCredit: any[] = [];
    dataUsingOverCredit: any[] = [];
    data: any[] = [];
    labels: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    siteId: number;
    hasLoaded: boolean = false;
    resizeTimer;


    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngAfterViewInit() {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });  
    }

    onInitialise() {        
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        if (this.clientId == null || this.clientId == undefined) this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        if (!this.hasLoaded) {
            this.issueService.issuePAYGEmergencyCreditSummary(this.clientId, this.siteId).then((result) => {
                let resultData = result as any;
                this.polarAreaData = result as any;
                this.data = [];
                this.labels = [];
                if (resultData.consumersNotBeyondEmergencyCreditLimit > 0 || resultData.consumersNotUsingOverCreditLimit > 0
                    || resultData.consumersUsingOverCreditLimit) {

                    if (resultData.consumersNotBeyondEmergencyCreditLimit > 0) {
                        this.data.push(resultData.consumersNotBeyondEmergencyCreditLimit);
                        this.labels.push('Not beyond E/C');
                    }

                    if (resultData.consumersNotUsingOverCreditLimit > 0) {
                        this.data.push(resultData.consumersNotUsingOverCreditLimit);
                        this.labels.push('Beyond E/C, no consumption');
                    }

                    if (resultData.consumersUsingOverCreditLimit > 0) {
                        this.data.push(resultData.consumersUsingOverCreditLimit);
                        this.labels.push('Beyond E/C, consumption');
                    }
                    this.createChart();
                }

            });
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    private getChartConfig(): any {
        let config = {
            type: 'doughnut',
            options: {
                rotation: 1 * Math.PI,
                circumference: 1 * Math.PI,
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                maintainAspectRatio: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                        scaleLabel: {
                            display: false,
                            labelString: 'Amount Days',
                            fontSize: 15,
                        },
                    }],
                    yAxes: [
                        {
                            display: false,
                            scaleLabel: {
                                display: false,
                                labelString: 'Amount',
                                fontSize: 15,
                                fontStyle: "bold",
                            },
                        },
                    ]

                }
            }
        }

        return config;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            this.createChart();
        }, 250);
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        datasets.push({
            data: this.data,
            backgroundColor: ['#93c01f', '#FFC000', '#c82b2b'],
            pointRadius: 3,
            borderWidth: 2,
            pointHoverRadius: 8,
            pointHitRadius: 10,
            borderColor: ['#93c01f', '#FFC000', '#c82b2b'],
            pointBorderColor: ['#93c01f', '#FFC000', '#c82b2b'],
            pointBackgroundColor: ['#93c01f', '#FFC000', '#c82b2b'],
            pointHoverBackgroundColor: ['#93c01f', '#FFC000', '#c82b2b'],
            pointHoverBorderColor: ['#93c01f', '#FFC000', '#c82b2b'],
        });

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                datasets: datasets,
                labels: this.labels
            }
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            if (!this.basechart || !this.basechart.first) return;
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }
}
